import Query from '../../../components/Report';

const query = new Query('search-keywords-keywords-list');

export default query;
